<div class="cliente-arquivo">
    <div class="cliente-arquivo-body">
        <ng-template [ngIf]="!editMode">
            <sgt-arquivo-upload-card-view
                [(arquivosUpload)]="arquivosUpload"
                (arquivosUploadChange)="arquivosUploadChange.emit($event)"
                [referencia]="referencia"
                [idReferencia]="idCliente"
                [canEdit]="canEdit"
                [headerText]="mensagemInformativa"
                idTable="clienteInsertArquivosTable">
            </sgt-arquivo-upload-card-view>
        </ng-template>
    
        <ng-template [ngIf]="editMode">
            <sgt-arquivo-card-view
                #cardView
                [referencia]="referencia"
                [idReferencia]="idCliente"
                [canEdit]="canEdit"
                [headerText]="mensagemInformativa"
                idTable="clienteArquivosTable">
            </sgt-arquivo-card-view>
        </ng-template>    
    </div>
</div>